import {handles} from "../adapters/backbone-decorators";
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import CampaignConfiguration from 'js/models/campaign.config.model';
import UserModel from 'js/models/userrelatedinfo.model';
import ServicesView from 'js/views/services.view';
import SelectionView from 'js/views/selection.view';
import ContentTilesView from 'js/views/content.tiles.view';
import ContentFileUploadView from 'js/views/contentfileupload.view';
import ContentTemplate from 'js/templates/content.tile.selected.hbs';
import MessageErrorTemplate from 'js/templates/messageError.hbs';
import moment from 'moment';
import i18n from 'l10n';
import ServiceModel from 'js/models/service.config.model';
import Graphable from 'js/traits/graphable.trait';
import dhtmlx from 'dhtmlxAdapter';
import Optional from 'optional-js';
import {mixin, model, on, tagName} from "js/adapters/backbone-decorators";

const {parser: Parser} = require('tellody');
const {Backbone, _} = require('backboneAdapter');

require('jqueryTagManager');

function regexEsc(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

// noinspection JSUnusedGlobalSymbols
@mixin(Graphable)
@tagName('div')
@model(CampaignConfiguration, {contactIds: [], includedGroups: [], message: ""})
class MessageGenericView extends GenericView {
    constructor(options) {
        super();
        this.flag = false;
        this.className = '';
        this.isMessageSaved = true;
        this.voucherNotificationShown = false;
        this.surveyNotificationShown = false;
        this.campaignNotificationShown = false;
        this.messageErrorTemplate = Handlebars.compile(MessageErrorTemplate);
        this.isContentValid = true;
        this.isUrlValid = true;
        this.isVoucherValid = true;
        this.isCampaignValid = true;
        this.isSurveyValid = true;
        this.isVoucherPreviewed = true;
        this.isCampaignPreviewed = true;
        this.isSurveyPreviewed = true;
        this.isFilePreviewed = true;
        this.isFirstRender = true;
        this.shouldRender = true;
        this.areCreditsEnough = true;
        this.isTriggeredByKeyPress = false;
        this.dependenciesSmsCost = 0;
        this.dependenciesOfVoucherSmsCost = 0;
        this.dependenciesOfSurveySmsCost = 0;
        this.i18n = i18n;
        this.ContentTemplate = ContentTemplate;

        this.awaitingSavingOfFields = false;

        this.model = options.model;
        this.options = options;
        this.whitelist = undefined;
        this.bootstrapView().then(() => console.log("Message Generic ready."));

        this.setupAutoSaveCheck();
    }

    async bootstrapView() {
        if (!this.options.isMessageReport) {

            this.autoCompleteUrls = await $.getDefaultJSONQ("/CampaignCloud/Config/urls");
            await this.load();
            await this.checkForTrialAccount();

            if (this.model.get("campaignId") === 0) {
                $(window)
                    .unbind("datetimepicker:clearDateButtonClicked")
                    .on("datetimepicker:clearDateButtonClicked", (event, attribute, objectId) => {
                        if (objectId === this.model.get("id") && attribute === "startDate") {
                            this.setStartDateToNow(attribute);
                        }
                    });

                $(window).unbind("datetimepicker:focusout").on("datetimepicker:focusout", (event, attribute, objectId) => {
                    if (objectId === this.model.get("id")) {
                        const startDateInput = $(`#${attribute}Config`).find("form").find("input")
                        $(`#${attribute}Config`).find("form").submit();
                    }
                });

            }
        }

        this.on("changed:campaignStatus", response => {
            console.info(response);
            if (this.model.get("id") === response.id) {
                location.reload();
            }
        });
    }

    fetchAutoComplete() {
        return this.autoCompleteUrls;
    }

    showPills() {
        $(".tags-container .tag-container:not(.active)").addClass("active");
    }

    hidePills() {
        $(".tags-container .tag-container.active").removeClass("active");

        var $tagsToShow = $("." + $(".selection-tabs-container .selection-tab-btn.active").data("tags") + "-tags-container");
        $tagsToShow.addClass("active");
    }

    render(modelExtension) {
        this.model.set("subscriptionLevel", this.userModel.get("subscriptionLevel"));
        super.render(modelExtension);
        if (!this.options.isMessageReport) {
            this.showDependencyGraph();
            this.hideMessageButtons("");
            this.hideMessageButtons("2");
            this.voucherModel = new ServiceModel();
            this.surveyModel = new ServiceModel();
            //TODO WTF is this async call doing here?
            this.loadService('voucher');
            this.loadService('survey');
            const serviceAction = (serviceType, frame) => {
                this.toggleServicePreview(serviceType);
                if ($(frame.find(".heading")[0]).hasClass("collapsed"))
                    this.refreshFilePreview();
                this.trigger("opened:EditingSelectingContent");
            };
            this.voucherAccordion = this.$("#voucher-options .accordion");
            this.voucherAccordion.accordion({
                action: _.partial(serviceAction, "voucher", _)
            });
            this.surveyAccordion = this.$("#survey-options .accordion");
            this.surveyAccordion.accordion({
                action: _.partial(serviceAction, "survey", _)
            });
            this.contactsAccordion = this.$("#select-contacts .accordion");
            this.contactsAccordion.accordion({
                action: frame => {
                    if (this.model.get("campaignId") === 0 || this.isCampaignScheduled(this.model)) {
                        if ($(frame.find(".heading")[0]).hasClass("collapsed")) {
                            frame.find(".accordion-prompt").text(i18n.t("message.editrecipients"));
                            if (this.contactsCollapsed) {
                                this.contactsCollapsed();
                            }
                            this.showPills();
                        } else {
                            frame.find(".accordion-prompt").text(i18n.t("content.close"));
                            this.selectionView.redrawContacts(null, null);
                            if (this.contactsExpanded) {
                                this.contactsExpanded();
                            }
                            this.hidePills();
                        }
                        $($("#contactssearchbox").find(".searchbox")).val(""); //empty the searchbox's content
                    }
                }
            });

            if (this.model.get("description") === "tellody-event") {
                this.voucherModel2 = new ServiceModel();
                this.surveyModel2 = new ServiceModel();
                this.loadTriggering();
                this.campaignAccordion = this.$("#triggering-event .accordion");
                this.campaignAccordion.accordion({
                    action: () => {
                        // if(this.isCampaignPreviewed)
                        //     frame.find(".content").show();
                        this.toggleServicePreview("campaign");
                        this.toggleEventSelectionAlertMessage();
                    }
                });
                this.campaignView = new ServicesView({
                    voucher: true,
                    survey: true,
                    optin: true,
                    quiz: true,
                    instantWin: true,
                    payPalPayment: true,
                    el: "#triggering-event .services",
                    usedFor: "trigger",
                    trigger: this.model.get("triggeringCriterionExpression"),
                    // voucherForUniqueCode: this.model.get("voucherForUniqueCode"),
                    // surveyForUniqueCode: this.model.get("surveyForUniqueCode"),
                    campaignTemplateType: this.model.get("campaignTemplateType"),
                    campaignNotStarted: this.isCampaignScheduled() || this.model.get("campaignId") === 0,
                    sendDate: this.model.get("startDate"),
                    embedded: true
                });

                this.bindSelectedServiceEvent(this.campaignView);
            }
            this.file_content_accordion = this.$($("#select-file-content").find(".accordion")[0]);
            this.file_content_accordion.accordion({
                action: frame => {
                    if (this.model.get("campaignId") === 0) {
                        if ($(frame.find(".heading")[0]).hasClass("collapsed")) {
                            frame.find(".accordion-prompt").text(i18n.t("message.taptoselect"));
                            this.isFilePreviewed = false;
                            this.toggleFilePreview();
                        } else {
                            frame.find(".accordion-prompt").text(i18n.t("message.selectcontenttitle"));
                            this.isFilePreviewed = true;
                            this.toggleFilePreview();
                        }
                        this.trigger("opened:EditingSelectingContent");
                    }
                }
            });
            this.contentTilesView = new ContentTilesView({
                el: "#select-file-content .fileContent",
                inPromoConfiguration: true,
                selectedFile: this.model.get("contentForUniqueCode")
            });

            this.contentTilesView.off("selected:content").on("selected:content", e => {
                this.insertContentOnCampaign(e);
                $.Dialog.close();
            }, this);

            this.contentFileUploadView = new ContentFileUploadView({
                el: $(".optional-upload-view"),
                dropZone: 'body',
                model: new Backbone.Model({
                    uploadUrl: "/CampaignCloud/Content/UploadContent"
                }),
                inVoucherConfiguration: false
            });
            this.refreshServices();
            this.selectionView = new SelectionView({
                el: "#select-contacts .content",
                CCview: this,
                campaignChannel: this.model.get("campaignChannel"),
                postpaid: this.userModel.get("postpaid")
            });

            /* Initialize tag manager on selectionView
            ** load
            ** TODO see if it would be better included
            ** in subscriber.select.listgroup.row.view
            */

            this.selectionView.on("rendered:contacts", _.bind(this.prepareBubbles, this));

            this.selectionView.load();

            this.getTargetingSize(() => this.validateMessageCondition());

            if (this.model.get("contentForUniqueCode")) {
                this.showContent();
            }
            this.fillUrls();
            if (this.userModel.get("postpaid")) {
                $("#message-options").remove();
                if (this.isSms) {
                    $("#error-credits-message").parent().remove();
                }
            } else {
                $("#message-options").show();
            }

            this.renderShops();
        }
        return this;
    }

    bindSelectedServiceEvent(servicesView) {
        servicesView.off("selected:service").on("selected:service", event => {
            console.info("Service selected: ", event);
            if (this.model.get("campaignId") === 0) {
                this[event.method](event.model, event.originalEvent, event.extra);
            }
        });
    }

    renderShops() {
        const shopListTemplate = Handlebars.compile(require("js/templates/partials/woo.shop.list.hbs"));
        const shops = this.wooShops.map(s => _.extend({}, {isSelected: this.ids && this.ids.includes(s.id)}, s));
        this.$el.find("#woocommerce-events").append(shopListTemplate(shops));
    }

    getGroupTag(groupModel) {
        const trimmedTitle = groupModel.get("title").trim();
        const groupTag = trimmedTitle ? trimmedTitle : i18n.t("groups.noname");

        const rx = new RegExp(regexEsc(groupTag.replace(/\(\d+\)$/,'')) + "(\\(\\d+\\))?$");

        /*const emptyPos = _.chain(this.groupTags) //toDo: check why it always returns -1
            .keys()
            .map(rx.exec.bind(rx))
            .filter(_.identity)
            .map((acc, val) => val[2] ? val[2] : 0)
            .findIndex((x, i) => x !== i)
            .value();*/

        var regEx = new RegExp(regexEsc(groupTag.replace(/\(\d+\)$/,'')) + "(\\(\\d+\\))?$");
        var regExNumber = new RegExp("(\\(\\d+\\))$");

        var pos = -1;

        $.each(this.groupTags, function(key, val) {
            if(key.match(regEx) && key.match(regEx).index > -1) {
                if(key.match(regExNumber) && key.match(regExNumber).index > -1) {
                    pos = parseInt(key.match(regExNumber)[0].replace("(","").replace(")","")) + 1;
                }else {
                    pos = 1;
                }
            }
        });

        if (pos > 0)
            return `${groupTag}(${pos})`;
        else
            return `${groupTag}`;
    }

    getGroupId(groupName) {
        var groupNameMatcher = groupName.match(/Group(\d+)/);
        return groupNameMatcher ? groupNameMatcher[1] : -1;
    }

    getGroupModel(groupId) {
        return this.selectionView.groupsCollection.get(groupId);
    }

    async prepareBubbles() {
        /*************** INITIALIZATION SECTION *******************/
        this.contactTags = $("#contact-tags").tagsManager();
        this.simpleGroupTags = $("#group-tags").tagsManager();
        this.geoGroupTags = $("#geo-group-tags").tagsManager();

        this.geoGroups = [];
        this.geoGroupsData = {};

        this.nameTags = [];
        this.subscriptions = [];
        this.groupTags = {};
        try {
            let subs = this.subscriptions = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Subscription/getSubscriptionsFromIds',
                dataType: 'json',
                type: 'post',
                contentType: 'application/json',
                data: JSON.stringify({
                    subscriptionIds: this.model.get("contactIds"),
                    channel: this.model.get("campaignChannel")
                })
            });

            _.each(subs,
                subscription => {
                    let finalTag;
                    const lastname = subscription['lastName'].trim();
                    const fullname = `${lastname} ${subscription['firstName']}`.trim();
                    const fullContact = `${fullname} ${subscription['email/sms']}`.trim();

                    if (lastname && this.nameTags.includes(lastname))
                        finalTag = lastname;
                    else if (fullname && this.nameTags.includes(fullname))
                        finalTag = fullname;
                    else
                        finalTag = fullContact;

                    this.nameTags.push(finalTag);
                    var tagEl = this.contactTags.tagsManager("pushTag", finalTag);
                    tagEl.addClass(`simple-contact-tag ${subscription['subscriptionId']}`);
                }, this);

            _.each(this.model.get("includedGroups"),
                (groupName) => {
                    var groupModel = this.getGroupModel(this.getGroupId(groupName));
                    if (groupModel) {
                        var groupTag = this.getGroupTag(groupModel);
                        this.groupTags[groupTag] = groupModel;
                        var tagEl = this.simpleGroupTags.tagsManager("pushTag", groupTag);
                        if (tagEl) tagEl.addClass("group-contact-tag");
                    }else { //queryGroup - geo area
                        if(groupName.indexOf("q:in bounds") > -1) {
                            this.geoGroups.push(groupName);
                            var geoTag = "Geo-"+ (this.geoGroups.length - 1);
                            this.geoGroupsData[geoTag] = groupName;

                            var tagEl = this.geoGroupTags.tagsManager("pushTag", geoTag);
                            tagEl.addClass("geo-group-contact-tag");
                            tagEl.data("geo-key", geoTag);
                        }
                    }
                }, this);
            //Tag deletion event
            this.contactTags.on('tm:splicing', (e, tag) => {
                const subscriptionToDeselect = this.subscriptions.find(subscription => {
                    const lastName = subscription['lastName'].trim();
                    const fullname = `${lastName} ${subscription['firstName']}`.trim();
                    const fullContact = `${fullname} ${subscription['email/sms']}`.trim();

                    if (fullContact === tag)
                        return true;
                    else if (fullname === tag)
                        return true;
                    else return lastName === tag;
                });
                if (subscriptionToDeselect) {
                    var subscriptionId = subscriptionToDeselect['subscriptionId'];
                    const $2 = $(`#contact-item-${subscriptionId}`);
                    if ($2.length) {
                        $2.trigger('click');
                    } else {
                        const existingContacts = this.model.get("contactIds");
                        const index = this.model.get('contactIds').indexOf(subscriptionId);
                        existingContacts.splice(index, 1);
                        this.selectionView.CCview.changeTargeting(existingContacts, "contact");
                        this.selectionView.trigger("ContactDeselected", subscriptionId);
                    }
                }
            });

            this.simpleGroupTags.on('tm:splicing', (e, tag) => {
                var groupToDeselect = this.groupTags[tag];

                if (groupToDeselect) {
                    const selectedGroups = this.model.get("includedGroups");
                    const gidx = selectedGroups.indexOf(`Group${groupToDeselect.id}`);
                    selectedGroups.splice(gidx, 1);
                    $(`#group-${groupToDeselect.id}`).removeClass('selected');
                    delete this.groupTags[tag];
                    this.changeTargeting(selectedGroups, "group");
                } else {
                    console.log("GOT INTO ELSE on SIMPLE GROUPS");
                }
            });

            this.geoGroupTags.on('tm:splicing', (e, tag) => {
                var geoGroupToDeselect = this.geoGroupsData[tag];

                if(geoGroupToDeselect) {
                    const groupNumber = tag.split("-")[1];
                    const selectedGroups = this.model.get("includedGroups");

                    const gidx = selectedGroups.indexOf(geoGroupToDeselect);
                    selectedGroups.splice(gidx, 1);

                    delete this.geoGroupTags[tag];
                    delete this.geoGroupsData[tag];
                    var indx = this.geoGroups.indexOf(geoGroupToDeselect);

                    if(indx > -1) {
                        this.geoGroups.splice(indx, 1);
                        $("#geogroup-"+ groupNumber).remove();
                    }
                    this.changeTargeting(selectedGroups, "group");
                } else {
                    console.log("GOT INTO ELSE on GEO GROUPS");
                }
            });

        } catch (error) {
            console.error(error);
            $.Notify.error(i18n.t("error in getSubscriptionsFromIds"));
        }

        /****************** CONTACTS SECTION **********************/
        this.selectionView.on("ContactSelected", async id => {
            try {
                let subs = await $.ajaxDefaultQ({
                    url: '/CampaignCloud/Subscription/getSubscriptionsFromIds',
                    dataType: 'json',
                    type: 'post',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        subscriptionIds: [id],
                        channel: this.model.get("campaignChannel")
                    })
                });
                this.subscriptions = this.subscriptions.concat(subs);
                var contactModel;
                const s1 = subs[0]['lastName'].trim();
                const s2 = `${s1} ${subs[0]['firstName']}`.trim();
                const s3 = `${s2} ${subs[0]['email/sms']}`.trim();

                if (this.nameTags.includes(s1)) {
                    contactModel = s1;
                } else if (this.nameTags.includes(s2)) {
                    contactModel = s2;
                } else {
                    contactModel = s3;
                }
                this.nameTags.push(contactModel);
                var tagEl = this.contactTags.tagsManager("pushTag", contactModel);
                tagEl.addClass(`simple-contact-tag ${subs[0]['subscriptionId']}`);
            } catch (error) {
                console.error(error);
                $.Notify(i18n.t("error in getSubscriptionsFromIds"));
            }
        });

        this.selectionView.on("ContactDeselected", async id => {
            try {
                let subs = await $.ajaxDefaultQ({
                    url: '/CampaignCloud/Subscription/getSubscriptionsFromIds',
                    dataType: 'json',
                    type: 'post',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        subscriptionIds: [id],
                        channel: this.model.get("campaignChannel")
                    })
                });
                const index = _.findIndex(this.subscriptions, sub => sub['subscriptionId'] === subs[0]['subscriptionId']);
                this.subscriptions.splice(index, 1);
                let contactToDeselect;
                const s1 = subs[0]['lastName'].trim();
                const s2 = `${s1} ${subs[0]['firstName']}`.trim();
                const s3 = `${s2} ${subs[0]['email/sms']}`.trim();

                if (this.nameTags.includes(s3)) {
                    contactToDeselect = s3;
                } else if (this.nameTags.includes(s2)) {
                    contactToDeselect = s2;
                } else {
                    contactToDeselect = s1;
                }
                this.contactTags.data("deselectedFromRow", true);
                this.nameTags.splice(this.nameTags.indexOf(contactToDeselect), 1);
                this.contactTags.tagsManager("removeTag", contactToDeselect);
            } catch (error) {
                console.error(error);
                $.Notify(i18n.t("error in getSubscriptionsFromIds"));
            }
        });
        this.selectionView.on("selectAllContactsClicked", () => {
            this.contactTags.tagsManager("empty");
            this.simpleGroupTags.tagsManager("empty");
            this.geoGroupTags.tagsManager("empty");

            this.geoGroups = [];
            this.groupTags = {};
            this.geoGroupsData = {};
            this.nameTags = [];
        });
        /******************** GROUPS SECTION **********************/
        this.selectionView.on("GroupSelected",
            groupName => {
                var groupModel = this.getGroupModel(this.getGroupId(groupName));
                if (groupModel) {
                    var groupTag = this.getGroupTag(groupModel);
                    this.groupTags[groupTag] = groupModel;
                    var tagEl = this.simpleGroupTags.tagsManager("pushTag", groupTag);
                    if (tagEl) tagEl.addClass("group-contact-tag");
                }
            }, this);
        this.selectionView.on("GroupDeselected",
            groupName => {
                var groupModel = this.getGroupModel(this.getGroupId(groupName));
                if(groupModel) {
                    var groupTag = _.keys(_.pick(this.groupTags, function (el) {
                        return el === groupModel;
                    }))[0];

                    delete this.groupTags[groupTag];
                    this.simpleGroupTags.tagsManager("removeTag", groupTag)
                }else { //geo group
                    var geoTag = groupName; //in geo areas, we get the `Geo-${index}`, as the groupName

                    var indx = this.geoGroups.indexOf(this.geoGroupsData[groupName]);
                    delete this.geoGroupTags[geoTag];
                    delete this.geoGroupsData[geoTag];

                    if(indx > -1) {
                        this.geoGroups.splice(indx, 1);
                        $("#geogroup-"+ indx).remove();
                    }
                    this.geoGroupTags.tagsManager("removeTag", geoTag);
                    this.contactTags.data("deselectedFromRow", true);
                }



            }, this);
        /**********************************************************/
        this.selectionView.off("rendered:contacts");
    }

    setContactsExpanded(fn) {
        this.contactsExpanded = fn;
    }

    setContactsCollapsed(fn) {
        this.contactsCollapsed = fn;
    }

    async loadShops() {
        const {data} = await $.getDefaultJSONQ("/CampaignCloud/ApiUser/WooShops");
        this.wooShops = data;
    }

    async load(id) {
        await this.loadShops();
        await this.loadUser();
        this.render();
    }

    async loadUser(callback) {
        this.userModel = new UserModel();
        const userModel = await this.userModel.fetch();
        this.model.set("postpaid", this.userModel.get("postpaid"));
        if (_.isFunction(callback)) callback();
        return userModel;
    }

    refreshCampaignPreview(viewElement, selectedElement) {

        const $selected = $(selectedElement).first().closest(".balloonvoucher");
        $(viewElement).html($selected.clone());

        this.updateGraph();
    }

    async loadTriggering() {
        const triggeringCriterionExpression = this.model.get('triggeringCriterionExpression');
        if (triggeringCriterionExpression !== "false") {
            const [className, criteria] = triggeringCriterionExpression.split("\\");
            if (criteria) {
                if (criteria.includes("=")) {
                    const [criterion, criterionValue] = criteria.split("=");
                    if (criterionValue) {
                        this.id = criterionValue;
                    }
                } else if (criteria.includes(" in ")) {
                    const [criterion, criterionValue] = criteria.split(" in ");
                    if (criterionValue) {
                        this.ids = JSON.parse(criterionValue.replace('{', '[').replace('}', ']'));
                    }
                }
            }
            if (className === "RedeemVoucherEvent") {
                this.voucherModel2.url = `/CampaignCloud/Config/campaignId/${this.id}`;
                try {
                    let vm2 = await this.voucherModel2.fetch();

                    if (!vm2.title) {
                        this.$('#campaign-select').text(i18n.t("message.selectedEventWithNoTitle"));
                    } else {
                        this.$('#campaign-select').text(`${i18n.t("message.selectedEvent")} ${vm2.title}`);
                    }
                    this.validateCampaign();
                    this.toggleEventSelectionAlertMessage();
                    this.addAppropriateClassOnSelectedService('#campaignView', vm2.id, "voucher");
                } catch (e) {
                    console.error(e);
                }

            } else if (["WooCustomerCreationEvent",
                "WooCustomerUpdateEvent",
                "WooOrderCreationEvent",
                "WooOrderUpdateEvent",
                "TriggerEvent"].includes(className)) {

                this.selectedEvent = className;
                let $externalTriggersTab = this.$("#external-triggers-tab");
                $externalTriggersTab.siblings().removeClass("active");
                $externalTriggersTab.addClass("active");

                const $selectedTrigger = this.$("#external-event, #api-events")
                    .find(`[data-trigger=${className}]`);

                const targetId = $selectedTrigger.closest(".frame").attr("id");

                $selectedTrigger.closest('a').addClass('active');
                const $externalSource = $selectedTrigger.closest(".tab-control")
                                .find(".tabs")
                                .children()
                                .filter((_, el)=>$(el).find('a').attr("href") === "#" + targetId)

                $externalSource.siblings().removeClass("active");
                $externalSource.addClass("active");

                if($selectedTrigger.prop("tagName").toLowerCase() === "input" && $selectedTrigger.prop("checked") != false && this.selectedEvent == "TriggerEvent") {
                    $selectedTrigger.prop("checked", true);

                    // uncheck the "check" status of WooCommerce contact event
                    $($selectedTrigger.closest(".frame")).siblings().find("a").removeClass("active");

                    // remove the "selected" status of WooCommerce's selected shops
                    $($selectedTrigger.closest(".frame")).siblings().find("a.selected").each(function() {
                        $(this).click(); // trigger a click event, so the ids will be nullified
                    });
                } else {
                    $selectedTrigger.closest(".frame").siblings().find(`[data-trigger=TriggerEvent]`).prop("checked", false);
                }

                const event = i18n.t(`woocommerce.${className}`);
                this.$('#campaign-select').text(`${i18n.t("message.selectedEvent")} ${event}`);
                this.validateCampaign();
                this.toggleEventSelectionAlertMessage();
                this.addAppropriateClassOnSelectedService('#campaignView', null, "external");
            } else if (["SurveyAnswerRequest",
                "EmailOptedInEvent",
                "PayPalPaymentEvent",
                "InstantWinActedWinnerEvent",
                "InstantWinActedParticipantEvent"].includes(className)) {
                this.surveyModel2.url = `/CampaignCloud/Config/campaignId/${this.id}`;
                try {
                    let sm2 = await this.surveyModel2.fetch();
                    if (!sm2.title) {
                        this.$('#campaign-select').text(i18n.t("message.selectedEventWithNoTitle"));
                    } else {
                        this.$('#campaign-select').text(`${i18n.t("message.selectedEvent")} ${sm2.title}`);
                    }
                    this.validateCampaign();
                    this.toggleEventSelectionAlertMessage();
                    var service = className === "SurveyAnswerRequest" ? "survey"
                        : className === "EmailOptedInEvent" ? "optin"
                            : className === "PayPalPaymentEvent" ? "payment"
                                : className === "InstantWinActedWinnerEvent" || className === "InstantWinActedParticipantEvent"
                                    ? "instantWin"
                                    : "";

                    this.addAppropriateClassOnSelectedService('#campaignView', sm2.id, service);
                } catch (error) {
                    console.error(error);
                }
            }
        }
        this.refreshCampaignPreview('#campaignView', '#triggering-event .selected');
    }

    toggleEventSelectionAlertMessage() {

        const triggeringCriterionExpression = this.model.get('triggeringCriterionExpression');
        const hide = triggeringCriterionExpression && triggeringCriterionExpression.includes("\\");
        $('#campaign-message').toggle(!hide);
    }

    async loadService(serviceType) {
        const serviceModel = this[`${serviceType}Model`],
            selectElement = `#${serviceType}-select`,
            viewElement = `#${serviceType}View`;
        // todo check if these are useful
        // messageElement = `#${serviceType}-message`,
        // selectedElement = `#${serviceType}-options .selected`;
        const attr = this.model.get(`${serviceType}ForUniqueCode`);
        if (attr) {
            serviceModel.url = `/CampaignCloud/Config/campaignId/${attr}`;
            try {
                let sm = await serviceModel.fetch();

                if (!sm.title) {
                    this.$(selectElement).text(i18n.t(`voucher.selected${serviceType}withnotitle`));
                } else {
                    const selectedService = i18n.t(`message.selected${serviceType}`);
                    this.$(selectElement).text(`${selectedService} ${sm.title}`);
                }
                this.validateMessageCondition();
                this.addAppropriateClassOnSelectedService(viewElement, this.model.get(serviceType), serviceType);
            } catch (e) {
                console.error(e);
            }
        }
    }

    showTargeting(data) {
        var groupsCount = $.grep(this.model.get("includedGroups"), function(val, index) {
            return val.indexOf("q:in bounds") == -1;
        }).length;
        var geoGroupsCount = this.model.get("includedGroups").length - groupsCount;

        var text = i18n.t("message.contactsselected", {count: data[0]}) + " ("
                + i18n.t("message.groupsselected", {count: groupsCount}) +", "
                + i18n.t("message.geogroupsselected", {count: geoGroupsCount})
                + ")";

        if (this.model.get("contactIds").length === 0 && this.model.get("includedGroups").length === 0) {
            text = `${i18n.t("message.contactsselected", {count: data[0]})} (${i18n.t("message.all")})`;
        }
        this.$(".selected-contacts-tile").text(text);
    }

    showMessageButtons(idSuffix) {
        this.toggleExecuteButton(this.flag, this);
        $(`#editor-tile${idSuffix} button`).css("visibility", 'visible');
    }

    hideMessageButtons(idSuffix) {
        $(`#editor-tile${idSuffix} button`).css("visibility", 'hidden');
    }

    toggleServicePreview(serviceType) {
        const cappedST = $.capitalizeFirstLetter(serviceType);
        const serviceView = `#${serviceType}View`;
        if (this[`is${cappedST}Previewed`]) {
            $(serviceView).hide();
            this[`is${cappedST}Previewed`] = false;
        } else {
            $(serviceView).show();
            this[`is${cappedST}Previewed`] = true;
        }
    }

    /**
     * @return {boolean}
     */
    UURLTagAlreadyExists(messageText, tagText) {
        var parts = messageText.split(/[{}]/);
        parts = parts.filter(function (s) {
            return s !== "";
        });
        for (var k = 0; k < parts.length; k++) {
            var part = parts[k];
            if (part === tagText) {
                return true;
            }
        }
        return false;
    }

    @on("click #clone")
    cloneCampaign() {
        $.ajaxDefaultQ({
            url: `/CampaignCloud/Message/${this.model.get("id")}/clone`,
            type: 'POST',
            dataType: 'text'
        }).done(function (id) {
            location.href = `Message.htm#${id}`;
            location.reload();
        });
    }

    async getTargetingSize(callback) {
        var html = "<i class=\"icon-loading spin fg-funkyOrange header\"></i>";
        $(".selected-contacts-tile").html(html);
        if (this.isSms) {
            $("#credits-cost").html(html);
        }
        try {
            let data = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Message/${this.model.get("id")}/count`,
                type: 'GET',
                contentType: "application/json",
                dataType: 'json'
            });
            this.targetingSize = data[0];
            this.targetGroupSizeCost = data[1];
            this.targetingSizeWithoutCountryCodes = data[2];
            this.showTargeting(data);
            if (this.isSms) {
                this.showMessageOfUsableContacts(this, data);
            }
            if (callback) callback(data);
            return data;
        } catch (e) {
            console.error(e);
        }
        return null;
    }

    async getDependenciesSmsCount() {
        if (this.model && this.model.id) {
            try {
                let id = this.model.id;
                let data = await $.ajaxDefaultQ({
                    url: `/CampaignCloud/Message/${id}/dependenciesMessageCount`,
                    type: 'get',
                    contentType: "application/json",
                    dataType: 'json'
                });
                this.dependenciesSmsCount = data.dependenciesSmsCount;
                this.dependenciesOfVoucherSmsCount = data.dependenciesOfVoucherSmsCount;
                this.dependenciesOfSurveySmsCount = data.dependenciesOfSurveySmsCount;
                this.dependenciesEmailCount = data.dependenciesEmailCount;
                this.dependenciesOfVoucherEmailCount = data.dependenciesOfVoucherEmailCount;
                this.dependenciesOfSurveyEmailCount = data.dependenciesOfSurveyEmailCount;
                this.updateMessageCount();

            } catch (e) {
                $.Notify.error(i18n.t("generic.dependeciesSmsCostError"));
            }

        }
    }

    async getContent(callback) {
        try {
            if (!this.model.get("contentForUniqueCode")) return null;
            const data = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Content/LoadFileContent/${this.model.get("contentForUniqueCode")}`,
                type: 'GET',
                contentType: "application/json",
                dataType: 'json'
            });
            if (data && callback) {
                callback(data);
                return data;
            } else {
                return data;
            }
        } catch (e) {
            console.error(e);
        }
        return null;
    }

    async checkForTrialAccount() {
        try {
            /* TODO Replace with model fetch */
            let userInfo = await $.getDefaultQ('/CampaignCloud/UserInfo');
            if (userInfo.subscriptionLevel === 1) {
                let trialReport = await $.getDefaultQ('/CampaignCloud/Report/getTrialRemainingReport');
                this.emailsLeft = trialReport.REMAINING_EMAIL;
                this.updateMessageCount();
            } else {
                this.updateMessageCount();
            }
            this.setWhitelist(userInfo.whitelist);
        } catch (e) {
            console.error(e);
        }
    }

    setWhitelist(whitelist) {
        this.whitelist = whitelist || "";
        this.trigger('whitelist', whitelist);
    }

    @handles("whitelist")
    showWhitelist() {
        if (this.whitelist !== undefined && this.whitelist.length > 0) {
            this.$('#whitelistSection').show();
            this.$('#whitelist').text(this.whitelist);
        } else {
            this.$('#whitelistSection').hide();
            this.$('#whitelist').html(i18n.t('message.nowhitelist'));
        }
    }

    @on("click #execute-send")
    async execute(messageType, confirmMessageSendTitle, valueParam, callback1, callback2) {
        var isExpired = this.userModel.get("expirationDate") ? this.userModel.get("expirationDate").millis < new Date() : false;
        var isPostpaid = this.userModel.get("postpaid");
        var noRemainingEmails = !this.emailsLeft || (this.emailsLeft === 0);
        var userLevelTrial = this.userModel.get("subscriptionLevel") === 1;
        var remainingEmailsMoreThanTargetingSize = !this.emailsLeft || (this.emailsLeft >= (this.targetingSize * this.totalEmails));
        var campaignType = this.model.get("campaignChannel");

        if (!isPostpaid) {
            var titleText, textText;
            if (isExpired) {
                titleText = "profile.nopermissiontitle";
                textText = "profile.nopermissiontext";
                var firstButton = "profile.nopermissionfirstbutton";

                const result = await dhtmlx.modalbox({
                    title: i18n.t(titleText),
                    text: i18n.t(textText),
                    buttons: [i18n.t(firstButton), i18n.t("cancelbtn")]
                });
                if (result === "0") {
                    location.href = "Credits.htm";
                }

                return;
            } else if (userLevelTrial && campaignType === "EMAIL" && (noRemainingEmails || !remainingEmailsMoreThanTargetingSize)) {
                //disable message execution if emailsLeft == 0 (only on non-postpaid)

                titleText = noRemainingEmails
                    ? "profile.upgradeaccount"
                    : i18n.t("message.notEnoughEmail");

                textText = noRemainingEmails
                    ? "message.noRemainingEmails"
                    : i18n.t("message.selectedContactsOverRemainingEmail");

                var buttons = [i18n.t("credits.upgrade"), i18n.t("cancelbtn")];

                const result = await dhtmlx.modalbox({
                    title: i18n.t(titleText),
                    text: i18n.t(textText),
                    buttons: buttons
                });

                if (result === "0") {
                    location.href = "Credits.htm";
                }

                return;
            }
        }

        var hasNoValidContact = !this.targetingSize || (this.targetingSize <= 0);
        var isEventCampaign = this.model.get("campaignTemplateType") == "SMART_NOTIFICATION" || this.model.get("description") == "birthday" || this.model.get("description") == "nameday";

        if(hasNoValidContact &&  !isEventCampaign) {
            var titleText = "message.blockedContact";
            var textText = "message.blockedSelectedContact";

            await dhtmlx.modalbox({
                title: i18n.t(titleText),
                text: i18n.t(textText),
                buttons: ["OK"]
            });

            if(!this.$("#execute-send").hasClass("cursor-not-allowed"))
                this.$("#execute-send").addClass("cursor-not-allowed")

            return;
        }

        if (!this.$("#execute-send").hasClass("cursor-not-allowed")) {
            console.log(messageType + " LOG");
            this.voucherNotificationShown = false;
            this.surveyNotificationShown = false;
            this.totalEmailsToSend = this.targetingSize * this.totalEmails;
            var dictionaryTitle;
            var dictionaryText;
            var smsCount = {count: this.targetingSize * this.totalSms};
            var emailCount = {count: this.totalEmailsToSend};
            var isDependentWOBulk = false;
            var isDependentWithBulk = false;

            if (this.isMessageSavedFunc()) {
                if (this.model.get("description") === 'tellody-event') {
                    try {
                        let {outcome: calculatedDependencies} = await $.ajaxDefaultQ({
                            url: "/CampaignCloud/Config/calculateDependencies/" + this.model.get("id"),
                            type: 'POST',
                            contentType: "application/json",
                            dataType: 'json'
                        });
                        this.response = calculatedDependencies;
                        const {
                            message,
                            smsTotalCount,
                            smsTotalCountForAll,
                            emailTotalCount,
                            emailTotalCountForAll,
                            creditsCost,
                            targetingSize
                        } = calculatedDependencies;

                        isDependentWOBulk = message === 'dependentEventCampaigns';
                        isDependentWithBulk = message === 'dependentEventCampaignsWithBulk';

                        if (isDependentWOBulk || isDependentWithBulk) {

                            this.smsCount = smsTotalCount;
                            smsCount = {count: smsTotalCountForAll};
                            this.emailCount = emailTotalCount;
                            this.totalEmailsToSend = emailTotalCountForAll;
                            emailCount = {count: this.totalEmailsToSend};

                            if (!this.model.get("postpaid")) {
                                var smsCost = creditsCost;
                                this.creditsCost = smsCost ? smsCost : 0;
                            }
                            this.targetingSize = targetingSize;
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
                var maximumwording = i18n.t("message.amaximumof");

                dictionaryTitle = i18n.t("message.confirmcreate");
                dictionaryText =
                    "<div style='width:100%; display:inline-block; text-align:center;'><img src='../img/filetelly.png'/><br/>"
                    + (this.hasDependentSmsCampaigns || this.hasDependentEmailCampaigns
                    ? i18n.t("message.associated") + "<br>" : "");
                /** TODO account for targeting size in event campaigns with bulk */

                if (this.targetingSize > 0)
                    dictionaryText += i18n.t("message.willsend", {count: this.targetingSize});
                if (smsCount.count > 0)
                    dictionaryText += "<br>" + maximumwording + ' ' + i18n.t("message.smscount", smsCount);
                if (emailCount.count > 0)
                    dictionaryText += "<br>" + maximumwording + ' ' + i18n.t("message.emailcount", emailCount);
                if (this.model.get("description") === 'gdpr')
                    dictionaryText += "<br> <div class='alert alert-danger' style='margin-top : 15px; margin-bottom:15px;'> <b class='fg-red'><i class='icon icon-warning'></i>" + i18n.t("message.messagegpdrdanger") + "</b>: <b style='text-decoration: underline;'>" + i18n.t("message.messagegpdrcampaign") + "</b><br>" + i18n.t("message.messagegdprexception") + " </div>";

                if (!this.model.get("postpaid"))
                    if (this.creditsCost > 0)
                        dictionaryText += "<br>" + i18n.t("message.estimatedcost", {
                            count: this.creditsCost,
                            countFixed: this.creditsCost.toFixed(2)
                        }) + "<br>" + i18n.t("message.finalcostmaydiffer");
                    else if (!userLevelTrial) {
                        this.showExecuteCampaignPrompt(dictionaryTitle, dictionaryText, isDependentWOBulk);
                        return;
                    }
                this.removeExtras(valueParam);
                var ismessageValid = this.validateMessageCondition(this);
                if (ismessageValid) {
                    if (this.model.get("campaignChannel") === "EMAIL" && (!this.model.get("title") || (this.model.get("title") && !this.model.get("title").trim()))) {
                        const result = await dhtmlx.modalbox({
                            title: i18n.t("message.confirmation"),
                            text: i18n.t("message.createCampaignWithNoTitleConfirm"),
                            buttons: [i18n.t("message.yes"), i18n.t("message.no")]
                        });
                        if (result !== "1") {
                            this.showExecuteCampaignPrompt(dictionaryTitle, dictionaryText, isDependentWOBulk);
                        }

                    } else {
                        this.showExecuteCampaignPrompt(dictionaryTitle, dictionaryText, isDependentWOBulk);
                    }
                }
            } else {
                $.Notify.error(i18n.t("message.warningsaveordiscard"));
            }
        } else {
            if (this.model.get("description") === 'tellody-event') {
                this.toggleEventSelectionAlertMessage();
            }
        }
    }

    async showExecuteCampaignPrompt(dictionaryTitle, dictionaryText, isDependentWOBulk) {
        const result = await dhtmlx.modalbox({
            title: dictionaryTitle,
            text: (dictionaryText ? (dictionaryText + "</div>") : i18n.t("message.confirmationprompt")),
            buttons: [i18n.t("message.yes"), i18n.t("message.no")]
        });
        if (result === "0") {
            if (this.model.get("description") === 'tellody-event'
                && this.campaignView
                && !this.model.get("postpaid")
                && !isDependentWOBulk
                && this.userModel
                && this.userModel.get("creditsAvailable")
                && (this.userModel.get("creditsAvailable") < this.creditsCost)) {
                this.creditsNeeded = Math.round((this.response.creditsCost
                    - this.userModel.get("creditsAvailable")) * 100.0) / 100.0;
                const res2 = await dhtmlx.modalbox({
                    text: this.i18n.t("message.eventCampaignInsufficientCreditsMessage",
                        {count: this.creditsNeeded}),
                    buttons: [`  (${i18n.t("message.buy")}${
                        i18n.t("message.credits")})  <i class="icon-tellody-credits padding5" ></i>  `,
                        i18n.t("message.no")]
                });
                if (res2 === "0") {
                    location.href = "./Credits.htm?messageId=" + this.model.id;
                }
            } else {
                this.executeAjax(this);
            }
        }

    }

    async executeAjax(actor) {
        if (!actor) actor = this;
        try {
            this.disableCreateButton(false);

            if (this.model.hasChanged())
                await this.model.batchUpdate();

            const executionStatus = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Message/${actor.model.get("id")}/execute`,
                type: 'POST',
                contentType: "application/json",
                dataType: 'json'
            });
            if (executionStatus > 0) {
                var campaignTitle = actor.model.get("title") && actor.model.get("title").trim().length > 0
                    ? actor.model.get("title")
                    : `(${i18n.t("message.nonamemessage")})`;

                var mess;
                if (actor.model.get("description") === "birthday") {
                    mess = i18n.t("message.birthdayCampaignExecuted");
                } else if (actor.model.get("description") === "nameday") {
                    mess = i18n.t("message.namedayCampaignExecuted");
                } else if (actor.model.get("startDate")) {
                    mess = i18n.t("message.scheduledCampaignInQueue");
                } else if (actor.model.get("campaignTemplateType") === "SMART_NOTIFICATION") {
                    mess = i18n.t("message.triggeredCampaignExecuted");
                } else {
                    mess = i18n.t("message.campaignInQueue", {count: actor.targetingSize, title: campaignTitle});
                }

                var text = `<div style='width:100%; display:inline-block; text-align:center;'>
                            <img style='margin-bottom:30px !important' src='../img/sentcampaign.png'/><br/>${mess}
                            </div>`;

                dhtmlx.modalbox({
                    title: i18n.t("instantWin.endTitleTextWinner"),
                    text: text,
                    buttons: [i18n.t("message.ok")],
                    callback: function () {
                        location.reload();
                    }
                });
            }
        } catch (data) {
            console.error(data);
        }
    }

    disableCreateButton(){
        $('#create-campaign-spinner').css("display", "inherit");
        $('.icon-tellody-paperplane').css("display", "none");
        $('#execute-send').prop("disabled", true);
    }

    isMessageSavedFunc() {
        return $(".edit.editing").length <= 0 && !this.awaitingSavingOfFields;
    }

    toggleExecuteButton(bool) {
        if (!bool) {
            this.$("#execute-send").removeClass("bg-white bg-hover-white fg-green fg-hover-emerald ol-green")
                .addClass("bg-white bg-hover-white ol-red fg-orange fg-hover-red cursor-not-allowed");
        } else {
            this.$("#execute-send").removeClass("bg-white bg-hover-white ol-red fg-orange fg-hover-red cursor-not-allowed")
                .addClass("bg-white bg-hover-white fg-green fg-hover-emerald ol-green");
        }
    }

    async fillUrls() {
        try {
            const data = await $.ajaxDefaultQ({
                url: "/CampaignCloud/Config/urls",
                type: 'GET',
                contentType: "application/json",
                dataType: 'json'
            });
            data.forEach(item => this.$("#select-url").append($(`<option>${item}</option>`)));
        } catch (error) {
            console.error(error);
        }
    }

    @on("change #select-url")
    selectUrl() {
        var value = this.$("#select-url option:selected").text() ? this.$("#select-url option:selected").text() : null;
        $('#url-editable').find('input').val(value);
        $('#error-url-message').hide();
    }

    showUrlOptions() {
        this.$("#url-options").show();
    }

    hideUrlOptions() {
        this.$("#url-options").hide();
    }

    showFileOptions() {
        this.$("#select-file-content").show();
    }

    hideFileOptions() {
        this.$("#select-file-content").hide();
    }

    async refreshFilePreview() {
        const data = await this.getContent();
        if (!data) return;
        this.$(".selected-file-content-tile").text("");
        this.$(".selected-file-content-tile").text(`${i18n.t("message.selectedfile")} ${data.filename}`);

        var fileSelect = $("#fileView");
        if (data && data.fileType && data.fileType.startsWith("image")) {
            fileSelect.html(`<img src='/CampaignCloud/Content/LoadFileContentBytes/${
                this.model.get("contentForUniqueCode")}'/>`);
        } else {
            fileSelect.html("<img src='/CampaignCloud/cloudui/img/plain-file-icon.png'/>");
        }

    }

    toggleFilePreview() {
        if (this.isFilePreviewed) {
            $("#fileView").hide();
            this.isFilePreviewed = false;
        } else {
            $("#fileView").show();
            this.isFilePreviewed = true;
        }
    }

    showVoucherOptions() {
        if (this.allowAdvancedServices()) {
            this.$("#voucher-options").show();
            this.updateMessageCount();
        }
    }

    hideVoucherOptions() {
        this.$("#voucher-options").hide();
        this.updateMessageCount();
    }

    showSurveyOptions() {
        if (this.allowAdvancedServices()) {
            this.$("#survey-options").show();
            this.updateMessageCount();
        }
    }

    hideSurveyOptions() {
        this.$("#survey-options").hide();
        this.updateMessageCount();
    }

    getHasList(message) {
        return [
            {
                type: "voucher",
                hasUurl: message && (message.includes("{UURL.voucher}") || message.includes("{UURL.vouchercode}") || message.includes("{woo.coupon}") || message.includes("{woo.couponcode}")),
                modelUniqueCodeVariableName: "voucherForUniqueCode",
                title: "#voucher-select",
                message: "#voucher-message",
                defaultTitle: "message.selectvoucher",
                defaultMessage: "voucher.selectavouchernotification",
                preview: "#voucherView",
                model: this.voucherModel,
                options: "#voucher-options"
            },
            {
                type: "survey",
                hasUurl: message && message.includes("{UURL.survey}"),
                modelUniqueCodeVariableName: "surveyForUniqueCode",
                title: "#survey-select",
                message: "#survey-message",
                defaultTitle: "message.selectsurvey",
                defaultMessage: "survey.selectasurveynotification",
                preview: "#surveyView",
                model: this.surveyModel,
                options: "#survey-options"
            },
            {
                type: "download",
                hasUurl: message && message.includes("{UURL.download}"),
                modelUniqueCodeVariableName: "contentForUniqueCode",
                title: ".selected-file-content-tile",
                message: "#content-message",
                defaultTitle: "message.selectacontentnotification",
                defaultMessage: "message.nocontentselected",
                preview: "#fileView"
            },
            {
                type: "url",
                hasUurl: message && (message.includes("{UURL.url}") || message.includes("{UURL.urlcode}")),
                modelUniqueCodeVariableName: "urlForUniqueCode",
                preview: "#url-editable",
                defaultData: "generic.editclick"
            }
        ];
    }

    clearUurlOption(item) {
        if (!item.hasUurl && this.model.get(item.modelUniqueCodeVariableName)) {
            this.model.set(item.modelUniqueCodeVariableName, null);

            //nullify service model, in order to avoid requests to e.g. "checkIfServiceParticipatesInEventCampaign"
            if (item.model && item.model.get("campaignId")) {
                item.model.set("campaignId", null);

                if (item.options) {
                    $(item.options).find(".selected").removeClass("selected");
                }
            }

            if (item.type === "url") {
                $(item.preview).html(`<placeholder>${i18n.t(item.defaultData)}</placeholder>`);
            } else {
                $(item.preview).empty();
                $(item.title).text(i18n.t(item.defaultTitle));
                $(item.message).text(i18n.t(item.defaultMessage));
                $(item.message).show();
            }
            return true;
        }
        return false;
    }

    cleanUnusedUurlOptions(el) {
        //on EMAIL find the body of the iframe. on SMS we get directly the "message";
        var message = this.model.get("campaignChannel") === "EMAIL" ?
            $(el).find("form").find("iframe").contents().find("body").html()
            : el;
        if (!message || (message && !message.length)) {
            return;
        }
        var shouldUpdate = this.getHasList(message).map(this.clearUurlOption.bind(this)).reduce((acc, b) => acc && b);

        if (shouldUpdate)
            this.model.save();
    }

    removeExtras(value) {
        var parts = value.split(/[{}]/);
        parts = parts.filter(function (s) {
            return s !== "";
        });
        let {urlCount, voucherCount, surveyCount, contentCount} =
            _.countBy(parts, part => part.includes("UURL.") ? part.replace("UURL.", "") + "Count" : "trash");

        if (urlCount && urlCount === 0) {
            this.removeExtra('urlForUniqueCode');
        }
        if (voucherCount && voucherCount === 0) {
            this.removeExtra('voucherForUniqueCode');
        }
        if (surveyCount && surveyCount === 0) {
            this.removeExtra('surveyForUniqueCode');
        }
        if (contentCount && contentCount === 0) {
            this.removeExtra('contentForUniqueCode');
        }
    }

    removeExtra(attribute) {
        this.model.saveAttribute(attribute, null, (attributeName, value1, outcome) => {
            if ("OK" === outcome) {
                console.info("extra removed");
                if ((attributeName === 'voucherForUniqueCode' || attributeName === 'surveyForUniqueCode') && this.campaignView) {
                    $('#triggering-spinner').show();
                    this.campaignView.setTemplateCollectionData();
                }
            }
        });
    }

    unselectAndCollapse(element, target) {
        const $accordion = element.find(".accordion");
        $accordion.find(".heading").addClass("collapsed");
        $accordion.find(".content").hide();

        $accordion.find(".selected").removeClass("selected");
        if (target) target.addClass('selected');
    }

    unselectExternal() {
        this.$("#external-event").find("a").removeClass("active");
    }

    saveExternalEventConfig(wooEvent) {
        const criterion = this.ids ? `shopId in {${this.ids.join(',')}}` : true;
        const triggeringCriterionExpression = `${wooEvent}\\${criterion}`;

        return this.model.saveAttribute('triggeringCriterionExpression',
            triggeringCriterionExpression,
            (attributeName, value1, outcome) => {
                if ("OK" === outcome) {
                    $.Notify.show(i18n.t("generic.attributechanged", {
                        attributeName: attributeName,
                        value: value1,
                        outcome: i18n.t(`generic.=${outcome}`)
                    }));
                }
            }
        );

    }

    @on("click [data-trigger]")
    async selectExternal(event) {
        const wooEvent = $(event.currentTarget).data("trigger");

        try {
            await this.saveExternalEventConfig(wooEvent);
        } catch (e) {
            console.error("Couldn't save configuration!", e)
        }

        this.updateGraph();
        this.loadTriggering();
        this.campaignView.id = null;
        this.trigger("selected:triggeredEvent");

        this.$("#triggering-event").find(".accordion").find(".services").find(".selected").removeClass("selected");
        this.$('#campaignView').empty();

    }

    @on("click #woo-shop-list a")
    async clickShop(event) {
        const $ct = $(event.currentTarget);
        const alreadySelected = $ct.hasClass("selected");
        const shopId = $ct.data("shop-id");

        if (alreadySelected) {
            const ids = _.difference(this.ids, [shopId]);
            this.ids = _.isEmpty(ids) ? null : ids;
        } else
            this.ids = _.union(this.ids, [shopId]);

        try {
            await this.saveExternalEventConfig(this.model.get("triggeringCriterionExpression").split("\\")[0]);
            $ct.toggleClass("selected", !alreadySelected);
        } catch (e) {
            console.error(e);
        }
    }

    selectService(serviceId, event, serviceType) {
        var e, attr;
        let $cT = $(event.currentTarget);
        if ($cT.parents().filter(`#${serviceType}-options`).length === 1) {
            this.toggleServicePreview(serviceType);
            e = this.$(`#${serviceType}-options`);
            attr = `${serviceType}ForUniqueCode`;

            var value = serviceId;
            this.model.saveAttribute(attr, value, (attributeName, value1, outcome) => {
                if ("OK" === outcome) {
                    $.Notify.show(i18n.t("generic.attributechanged", {
                        attributeName: attributeName,
                        value: value,
                        outcome: i18n.t(`generic.=${outcome}`)
                    }));
                    this.refreshCampaignPreview(`#${serviceType}View`, `#${serviceType}-options .selected`);
                    this.loadService(serviceType);
                }
            });
        } else {
            this.toggleServicePreview("campaign");
            e = this.$("#triggering-event");

            const eventClass = serviceType === "survey" ? "SurveyAnswerRequest" : "RedeemVoucherEvent";
            const triggeringCriterionExpression = `${eventClass}\\campaignId=${serviceId}`;

            this.model.saveAttribute('triggeringCriterionExpression',
                triggeringCriterionExpression,
                (attributeName, value1, outcome) => {
                    if ("OK" === outcome) {
                        $.Notify.show(i18n.t("generic.attributechanged", {
                            attributeName: attributeName,
                            value: value,
                            outcome: i18n.t(`generic.=${outcome}`)
                        }));
                        this.refreshCampaignPreview('#campaignView', '#triggering-event .selected');
                        this.shouldRender = true;
                        this.loadTriggering();
                        this.campaignView.id = serviceId;
                        this.trigger("selected:triggeredEvent");
                    }
                });
        }
        this.unselectExternal();
        this.unselectAndCollapse(e, $cT);
    }

    selectVoucher(voucherId, event) {
        this.selectService(voucherId, event, "voucher");
    }

    selectSurvey(surveyId, event) {
        this.selectService(surveyId, event, "survey");
    }

    selectOptin(serviceId, event, type) {
        let $cT = $(event.currentTarget);
        let e;
        this.toggleServicePreview("campaign");
        // Remove font weight from the previously selected payment trigger, wherever that is
        $(".paymentSelectable").css("font-weight", 300);

        e = this.$("#triggering-event");
        this.unselectExternal();
        this.unselectAndCollapse(e, $cT);

        var triggeringCriterionExpression;
        //TODO check these assignments to 'this'. They don't seem to be doing anything
        switch (type) {
            case "instantWin":
                this.isTriggeredInstantWin = true;
                triggeringCriterionExpression = `InstantWinActedWinnerEvent\\campaignId=${serviceId}`;
                break;
            case "sweepstakes":
                this.isTriggeredInstantWin = true;
                triggeringCriterionExpression = `InstantWinActedParticipantEvent\\campaignId=${serviceId}`;
                break;
            case "quiz":
                this.isTriggeredQuiz = true;
                triggeringCriterionExpression = `InstantWinActedWinnerEvent\\campaignId=${serviceId}`;
                break;
            case "payment":
                triggeringCriterionExpression = `PayPalPaymentEvent\\campaignId=${serviceId}`;
                this.isTriggeredPayment = true;
                break;
            default:
                triggeringCriterionExpression = `EmailOptedInEvent\\campaignId=${serviceId}`;
                if (type === "paymentOptin")
                    this.isTriggeredPayment = true;
                else
                    this.isTriggeredOptin = true;
                break;
        }
        this.model.saveAttribute('triggeringCriterionExpression',
            triggeringCriterionExpression,
            (attributeName, value1, outcome) => {
                if ("OK" === outcome) {
                    $.Notify.show(i18n.t("generic.attributechanged", {
                        attributeName: attributeName,
                        value: serviceId,
                        outcome: i18n.t("generic.=" + outcome)
                    }));
                    this.refreshCampaignPreview('#campaignView', '#triggering-event .selected');
                    this.shouldRender = true;
                    this.loadTriggering();
                    this.campaignView.id = serviceId;
                    this.trigger("selected:triggeredEvent");
                }
            });
    }

    changeTargeting(existingTargets, type) {
        if (!type) throw "Targeting type was undefined";
        const attr = type === "contact" ? "contactIds" : "includedGroups";
        this.model.set(attr, existingTargets);
        var value = this.model.get(attr);
        this.model.saveAttribute(attr, value, async (attributeName, value1, outcome) => {
            $.Notify.show(i18n.t(`generic.${type}targetingchanged`, {
                attributeName: attributeName,
                value: value,
                outcome: i18n.t(`generic.=${outcome}`)
            }));
            if ("OK" !== outcome) {
                this.render();
            } else {
                await this.getTargetingSize();
                this.validateMessageCondition(this);
            }
        });
    }

    changeContent(existingContentId) {
        this.isFilePreviewed = false;
        this.toggleFilePreview();
        var e = this.$("#select-file-content");
        this.unselectAndCollapse(e);
        var attr = "contentForUniqueCode";
        this.model.set(attr, existingContentId);
        var value = this.model.get(attr);
        this.model.saveAttribute(attr, value, (attributeName, value1, outcome) => {
            $.Notify.show(i18n.t("generic.attributechanged", {
                attributeName: attributeName,
                value: value,
                outcome: i18n.t(`generic.=${outcome}`)
            }));
            if ("OK" !== outcome) {
                this.render();
            } else {
                this.validateMessageCondition();
                this.showContent();
                this.contentTilesView.renderCollection();
                this.contentTilesView.selectedFile = existingContentId;
                this.contentTilesView.renderCollection();
            }
        });
    }

    updateCallback(attributeName, value, outcome, e, settings) {
        if (outcome === "OK") {
            if ($(e).hasClass("criteriaExpression")) {
                value = value.substring(2);
                $(e).parent().find("[data-pseudoid]").attr("data-pseudoid", value);
            }
            this.refreshTargetingSize();
        } else if (outcome === "InvalidUrl") {
            $.Notify.error(i18n.t("url.invalidurl"));
            outcome = "Error";
        } else if (outcome === "UnknownHostname") {
            $.Notify.error(i18n.t("url.unknownhostname"));
            outcome = "Error";
        } else if (outcome === "None" && $(e).attr("data-permutation") && $(e).attr("data-permutation") === 'url') {
            $.Notify.error(i18n.t("virusTotal.none"));
            outcome = 'OK';
        } else if (outcome === "Phishing") {
            $.Notify.error(i18n.t("virusTotal.phishing"));
        } else if (outcome === "Error" && $(e).attr("data-permutation") && $(e).attr("data-permutation") === 'url') {
            $.Notify.error(i18n.t("virusTotal.none"));
        } else if (outcome === "Unavailable") {
            $.Notify.warn(i18n.t("virusTotal.unavailable"));
            outcome = "OK";
        }
        super.updateCallback(attributeName, value, outcome, e, settings);
    }

    handleUpdate(value, settings, e) {
        super.handleUpdate($(e).hasClass("criteriaExpression") ? `q:${value}` : value, settings, e);
    }

    validateEditableUrl(valueParam) {
        var value;
        var $editable = $('#url-editable');
        if (valueParam) {
            value = valueParam;
        } else {
            value = $editable.hasClass('editing') ? $editable.find('input').val() : $editable.text();
        }
        var token;
        if (this.isSms) {
            token = this.editor.getValue();
        } else {
            token = this.confMessage;
        }
        if (token.indexOf('{UURL.url}') <= -1 && token.indexOf('{UURL.urlcode}') <= -1) {
            this.isUrlValid = true;
            this.$('#url-message').hide();
            this.hideUrlOptions();
            this.urlIsValid($editable.find('input'));
        } else {
            this.showUrlOptions();
            var re = /^(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;
            if (!re.test(value)) {
                this.$('#error-url-message').text(i18n.t("message.errorurlmessage"));
                this.isUrlValid = false;
                this.urlIsInvalid($editable.find('input'));
            } else {
                this.isUrlValid = true;
                this.$('#error-url-message').text("");
                this.urlIsValid($editable.find('input'));
            }
        }
    }

    validateUrl() {
        var value = this.model.get("urlForUniqueCode");
        var $editable = $("#url-editable");
        var token;
        if (this.isSms) {
            token = this.editor.getValue();
        } else {
            token = this.confMessage;
        }
        if (token.indexOf('{UURL.url}') <= -1 && token.indexOf('{UURL.urlcode}') <= -1) {
            this.isUrlValid = true;
            this.$('#url-message').hide();
            this.hideUrlOptions();
            this.urlIsValid($editable);

            return null;
        } else {
            this.showUrlOptions();
            if (!value) {
                this.$('#error-url-message').text(i18n.t("message.errorurlmessage"));
                this.isUrlValid = false;
                this.urlIsInvalid($editable);

                return {
                    "type": i18n.t("message.error"),
                    "description": i18n.t("message.emptyField"),
                    "value": i18n.t('message.errorurlmessage')
                };
            } else {
                this.isUrlValid = true;
                this.$('#error-url-message').text("");
                this.urlIsValid($editable);

                return null;
            }
        }

    }

    showSpinners(element) {
        /*
         * Don't change the ifs because we want to recalculate canditate services of event upon
         * selecting a voucher or survey.
         */
        if (!this.isTriggeredByKeyPress) {
            $(element).show();
            if (this.campaignView) {
                $('#triggering-spinner').show();
                this.campaignView.setTemplateCollectionData();
            }
        }
    }

    validateCampaign() {
        if (this.shouldRender) {
            this.isCampaignValid = false;
            if (this.id) {
                const hasList = this.getHasList();

                const removeConflicts = serviceType => {
                    const serviceView = `${serviceType}sView`;
                    this[serviceView].id = this.id;
                    const suc = `${serviceType}ForUniqueCode`;
                    const dependencies =
                        Optional.ofNullable(this[`${serviceType}Model`].dependencyCampaignIds)
                            .orElse("")
                            .split(",")
                            .concat(String(this.model.get(suc)));
                    if (dependencies.includes(this.id)) {
                        this.removeExtra(suc);
                        this.clearUurlOption(hasList.find(i => i.type === serviceType));
                    }
                    $(`#${serviceType}-options-spinner`).show();
                    this[serviceView].setTemplateCollectionData();
                };

                removeConflicts("survey");
                removeConflicts("voucher");
                this.isCampaignValid = true;
                this.getDependenciesSmsCount();
                this.shouldRender = false;

                return null;
            } else if (this.model.get("triggeringCriterionExpression") && this.model.get("triggeringCriterionExpression").includes("\\")) {
                this.isCampaignValid = true;
                this.getDependenciesSmsCount();
                this.shouldRender = false;

                return null;
            }
        } else if (this.id || this.model.get("triggeringCriterionExpression") && this.model.get("triggeringCriterionExpression").includes("\\")) {
            return null;
        }
        return {
            type: i18n.t("message.error"),
            description: i18n.t("message.emptyField"),
            value: i18n.t('message.noEventSelected')
        };
    }

    validateService(serviceType) {
        let token;
        const stc = $.capitalizeFirstLetter(serviceType);
        if (this.isSms) {
            token = this.editor.getValue();
        } else {
            token = this.confMessage;
        }
        if (token.indexOf(`{UURL.${serviceType}}`) <= -1 && token.indexOf(`{UURL.${serviceType}code}`) <= -1) {
            this[`is${stc}Valid`] = true;
            this.$(`#${serviceType}-message`).hide();
            this[`hide${stc}Options`]();

            return null;
        } else {
            this[`show${stc}Options`]();
            var dateToCheck = this.model.get("startDate") === null ? Date.now() : moment(new Date(this.model.get("startDate")));
            this[`is${stc}Valid`] = false;

            var serviceModel = this[`${serviceType}Model`];
            var serviceCampaignId = serviceModel.get("campaignTemplateType") === "" ? null : serviceModel.get('campaignId');

            if (serviceModel && serviceCampaignId == null) {
                this[`is${stc}Valid`] = false;
                this.$(`#${serviceType}-message`).text(i18n.t(`${serviceType}.selecta${serviceType}notification`));
                this.$(`#${serviceType}-message`).show();

                return {
                    "type": i18n.t("message.error"),
                    "description": i18n.t("message.emptyField"),
                    "value": i18n.t(`${serviceType}.selecta${serviceType}notification`)
                };
            } else if (this[`${serviceType}Model`].get('endDate') === null || dateToCheck <= this[`${serviceType}Model`].get('endDate')) {
                this[`is${stc}Valid`] = true;
                this.$(`#${serviceType}-message`).hide();

                return null;
            } else {
                if (!this[`${serviceType}NotificationShown`] && !this.model.get("campaignId")) {
                    this[`${serviceType}NotificationShown`] = true;
                    this[`is${stc}Valid`] = false;
                    this.$(`#${serviceType}-message`).show();

                    if (this.model.get("startDate")) {
                        console.info(moment(new Date(this.model.get("startDate"))).locale('en'));
                        $.Notify.error(i18n.t(`${serviceType}.${serviceType}expirednotificationinspecifictime`));
                        this.$(`#${serviceType}-message`).text(i18n.t(`${serviceType}.${serviceType}expirednotificationinspecifictime`));

                        return {
                            type: i18n.t("message.error"),
                            description: i18n.t("message.serviceExpiration"),
                            value: i18n.t(`${serviceType}.${serviceType}expirednotificationinspecifictime`)
                        };
                    } else {
                        $.Notify.error(i18n.t(`${serviceType}.${serviceType}expirednotification`));
                        this.$(`#${serviceType}-message`).text(i18n.t(`${serviceType}.${serviceType}expirednotification`));

                        return {
                            type: i18n.t("message.error"),
                            description: i18n.t("message.serviceExpiration"),
                            value: i18n.t(`${serviceType}.${serviceType}expirednotification`)
                        };
                    }
                }
            }
            if (serviceType === "survey") {
                this.showSurveyValidity();
                if (this.model.get("description") === 'tellody-event')
                    this.showSpinners('#survey-options-spinner');

                return null;
            }
        }
    }

    validateContent() {
        var token;
        if (this.isSms) {
            token = this.editor.getValue();
        } else {
            token = this.confMessage;
        }
        if (token.indexOf('{UURL.download}') <= -1) {
            this.isContentValid = true;
            this.$('#content-message').hide();
            this.hideFileOptions();
            if (this.model.get("message").indexOf('{UURL.download}') > -1) {
                this.model.set("contentForUniqueCode", null);
                this.model.saveAttribute("contentForUniqueCode", null, function (attributeName, value1, outcome) {
                    if (outcome === "OK") {
                        $("#select-file-content").find(".selected").removeClass("selected");
                        $("#fileView").empty();
                        $.Notify.show(i18n.t("message.unselectedfile"));
                    }
                });
            }
            return null;
        } else {
            this.isContentValid = false;
            this.showFileOptions();
            if (this.model.get("contentForUniqueCode") === null) {
                this.isContentValid = false;
                this.$('#content-message').text(i18n.t('message.selectacontentnotification'));
                this.$('#content-message').show();

                return {
                    "type": i18n.t("message.error"),
                    "description": i18n.t("message.emptyField"),
                    "value": i18n.t("message.selectacontentnotification")
                };
            } else {
                this.$('#content-message').hide();
                this.isContentValid = true;

                return null;
            }
        }
    }

    showSurveyValidity() {
        if (!this.isSurveyValid) {
            this.$("#survey-options").removeClass("bd-lightBlue").addClass("bd-darkRed");
        } else {
            this.$("#survey-options").removeClass("bd-darkRed").addClass("bd-lightBlue");
        }
    }

    showContent() {
        this.refreshFilePreview();
    }

    startDateSubmit(input) {
        var inputToDate = new Date(input.val());

        if(inputToDate < Date.now()) {

            // if campaign is scheduled, show  an appropriate popup that the value can not be changed to one that is
            // before the current date and time, and revert it to its previous value
            if (this.isCampaignScheduled()) {

                var oldValue = this.model.get('startDate'); //in millis
                var formattedDatetime = Handlebars.helpers.timestamp(oldValue, "YYYY/MM/DD HH:mm");

                // revert the datetime input
                input.val(formattedDatetime);

                dhtmlx.alert(i18n.t("message.notBeforeNowExecutionDateOnScheduled", {"previousDate": formattedDatetime}));

            } else {
                dhtmlx.alert(i18n.t("message.notpreviousactivationdateavailable"));

            }

        } else {
            var value = inputToDate.getTime();
            const attr = "startDate";

            this.awaitingSavingOfFields = true;

            this.model.setNestedAttribute(attr, value);

        }


        this.validateMessageCondition();
        this.refreshServices();
        this.checkForInvalidServicesAndClearThem();
    }

    setStartDateToNow(attr) {
        // no need to update an attribute with the same value
        if(this.model.get(attr) == null)
            return;

        this.model.set(attr, null);

        var $config = $("#" + attr + "Config");

        $config.text(i18n.t("now"));
    }

    urlIsValid(input) {
        var $error = $('#error-url-message');
        $error.empty();
        $error.hide();
        $('#url-options').removeClass("bd-lightRed").addClass("bd-lightBlue");
        $("#execute-send").show();
        $(input).removeClass("invalid").addClass("valid");
    }

    urlIsInvalid(input) {
        $('#url-options').removeClass("bd-lightBlue").addClass("bd-lightRed");
        var $error = $('#error-url-message');
        $error.text(i18n.t("message.errorurlmessage"));
        $error.show();
        $(input).removeClass("valid").addClass("invalid");
    }

    urlSubmit(input) {
        this.validateEditableUrl();
        if (input.hasClass('valid')) {
            $("#execute-send").removeAttr('disabled');
        } else {
            return false;
        }
    }

    onTestUrl(data) {
        if (data.outcome && data.outcome === "OK") {
            this.$('#error-url-message').text(i18n.t("message.errorurlunavailable")).hide();
        } else {
            this.$('#error-url-message').text(i18n.t("message.errorurlunavailable")).show();
        }
    }

    allowAdvancedServices() {
        var isRightLevel = this.userModel.get("subscriptionLevel") > 0;  //todo revisit this if subscription levels change
        var isNotExpired = this.userModel.get("expirationDate") ? this.userModel.get("expirationDate").millis >= new Date() : true;
        if (isRightLevel && isNotExpired) {
            return true;
        } else {
            var titleText;
            var textText;
            var firstButton;
            if (!isNotExpired) {
                titleText = "profile.nopermissiontitle";
                textText = "profile.nopermissiontext";
                firstButton = "profile.nopermissionfirstbutton";
            }
            if (!isRightLevel) {
                titleText = "voucher.nopermissiontitle";
                textText = "voucher.nopermissiontext";
                firstButton = "voucher.nopermissionfirstbutton";
            }
            dhtmlx.modalbox({
                title: i18n.t(titleText),
                text: i18n.t(textText),
                buttons: [i18n.t(firstButton), i18n.t("cancelbtn")],
                callback: function (result) {
                    if (result === "0") {
                        location.href = "Credits.htm";
                    }
                }
            });
            return false;
        }
    }

    async refreshTargetingSize() {
        await this.getTargetingSize();
        this.validateMessageCondition(this);
    }

    refreshServices(types) {
        if (!types) types = ["voucher", "survey"];

        //fix for NULL date
        var dateToCheck = this.model.get("startDate") != null ? this.model.get("startDate") : Date.now();

        types.forEach(t => {
            const servicesView = new ServicesView({
                [t]: true,
                el: `#${t}-options .content`,
                usedFor: t,
                embedded: true,
                campaignTemplateType: this.model.get("campaignTemplateType"),
                voucherForUniqueCode: this.model.get("voucherForUniqueCode"),
                surveyForUniqueCode: this.model.get("surveyForUniqueCode"),
                campaignNotStarted: this.isCampaignScheduled() || this.model.get("campaignId") === 0,
                sendDate: dateToCheck
            });

            this.bindSelectedServiceEvent(servicesView);
            this[`${t}sView`] = servicesView;
        });
    }

    commonCallback(isCampaignValid, attribute, contentElement, messageElement, viewElement, selectElement) {
        var serviceType = attribute == "voucherForUniqueCode" ? "voucher" : "survey";
        var serviceModel = this[`${serviceType}Model`];

        //shouldNullifyModelAttribute: if there was already a selected service, and was removed
        var shouldNullifyModelAttribute = serviceModel != null && this.model.get(attribute) == null;

        if (this.model.get("campaignChannel") === 'EMAIL') {
            if (this.confMessage.indexOf(`{UURL.${serviceType}`) <= -1 && this.model.get("message").indexOf(`{UURL.${serviceType}`) > -1) {
                this.checkForInvalidServicesBaseChannelAndClearThem(messageElement, selectElement, attribute, contentElement, viewElement)
            }
        } else if (this.model.get("campaignChannel") === 'SMS') {
            if (this.model.get("message").indexOf(`{UURL.${serviceType}`) <= -1) {
                this.checkForInvalidServicesBaseChannelAndClearThem(messageElement, selectElement, attribute, contentElement, viewElement)
            }
        }
    }

    //This check if exists a service and clear it
    checkForInvalidServicesBaseChannelAndClearThem(messageElement, selectElement, attribute, contentElement, viewElement) {
        this.model.set(attribute, null);
        this.model.saveAttribute(attribute, null, function (attributeName, value1, outcome) {
            if (outcome === "OK") {
                $(contentElement).find(".selected").removeClass("selected");
                $(viewElement).empty();

                //The specific function is only used to check for Surveys and Vouchers
                let serviceName = attributeName == "voucherForUniqueCode" ? "voucher" : "survey";

                $(messageElement).text(i18n.t(serviceName + '.selecta'+ serviceName +'notification'));
                $(selectElement).text(i18n.t("message.select"+ serviceName));

                $.Notify.show(i18n.t("message.unselected"+ serviceName));
            }
        });
    }


    checkForInvalidServicesAndClearThem() {
        this.commonCallback(this.isSurveyValid, 'surveyForUniqueCode', "#survey-options .content", '#survey-message', "#surveyView", '#survey-select');
        this.commonCallback(this.isVoucherValid, "voucherForUniqueCode", "#voucher-options .content", '#voucher-message', "#voucherView", '#voucher-select');
        if (this.model.get("description") === "tellody-event") {
            //TODO check if this.isCampaignTriggeredValid is ever initialized
            this.commonCallback(this.isCampaignTriggeredValid, 'surveyForUniqueCode', '#triggering-event .services', '#campaign-message', '#campaignView', '#campaign-select');
            this.commonCallback(this.isCampaignTriggeredValid, 'voucherForUniqueCode', '#triggering-event .services', '#campaign-message', '#campaignView', '#campaign-select');
        }
    }

    checkQuery(input) {
        var query = $(input).val().trim();
        if (!query) {
            return true;
        } else {
            try {
                Parser.parse(query);
            } catch (err) {
                return false;
            }
            return true;
        }
    }

    triggerQueryBlur(input) {
        $('#trigger-error-message').empty();
        $(input).removeClass("invalid").addClass("valid");
    }

    querySubmit(input) {
        return $(input).hasClass('valid');
    }

    reactionQueryBlur(input) {
        $('#reaction-error-message').empty();
        $(input).removeClass("invalid").addClass("valid");
    }

    controlGroupPercentageBlur(input) {
        $('#controlGroupPercentage-error-message').empty();
        $(input).removeClass("invalid").addClass("valid");
    }

    checkTriggerQuery(input) {
        var $trigger = $('#trigger-error-message');
        $trigger.empty();
        $(input).removeClass("invalid").addClass("valid");
        if (!this.checkQuery(input)) {
            $trigger.addClass('confirm-failure').empty().append(i18n.t("message.invalidTriggerCriterion"));
            $(input).removeClass("valid").addClass("invalid");
        }
    }

    checkReactionQuery(input) {
        var $reaction = $('#reaction-error-message');
        $reaction.empty();
        $(input).removeClass("invalid").addClass("valid");
        if (!this.checkQuery(input)) {
            $reaction.addClass('confirm-failure').empty().append(i18n.t("message.invalidReactionCriterion"));
            $(input).removeClass("valid").addClass("invalid");
        }
    }

    checkControlGroupPercentage(input) {
        var $controlGroupPercentage = $('#controlGroupPercentage-error-message');
        $controlGroupPercentage.empty();
        $(input).removeClass("invalid").addClass("valid");
        if (!this.checkCGP(input)) {
            $controlGroupPercentage.addClass('confirm-failure').empty().append(i18n.t("message.invalidControlGroupPercentage"));
            $(input).removeClass("valid").addClass("invalid");
        }
    }

    checkCGP(input) {
        return $(input).val().trim() >= 0 && $(input).val().trim() <= 100;
    }

    updateReserved(attribute, value) {
        if (!this.userModel.get("postpaid")) {
            if (this.model.get("description") === "tellody-event") {
                this.updateReservedAjax(this.model.get("id") + '/EventCampaignReserveCreditsAndEmails/' + attribute, value, attribute);
            } else if (this.isCampaignScheduled(this.model)) {
                this.updateReservedAjax(this.model.get("campaignId") + '/Scheduled/' + attribute, value, attribute);
            }
        }
    }

    async updateReservedAjax(endPoint, value, attribute) {
        try {
            const response = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Message/' + endPoint,
                type: 'POST',
                data: JSON.stringify(value),
                dataType: 'text',
                contentType: 'application/json',
                headers: {'Accept': 'application/json'}
            });
            const jsonResp = JSON.parse(response);
            if (jsonResp.error) {
                await dhtmlx.alert(jsonResp.error);
                location.reload();
                return;
            }

            if (jsonResp.message && (jsonResp.message === 'notEnoughEmail' || jsonResp.message === 'notEnoughCredits')) {
                var emailOrCreditNeeded = jsonResp.message === 'notEnoughEmail'
                    ? jsonResp.emailNeeded
                    : jsonResp.creditsNeeded;
                var textText = jsonResp.message === 'notEnoughEmail'
                    ? i18n.t("message.notEnoughEmailPrompt", {emailNeeded: emailOrCreditNeeded})
                    : i18n.t("message.notEnoughCredits", {creditsNeeded: parseFloat(emailOrCreditNeeded).toFixed(1)});
                var okText = i18n.t("profile.upgradeaccount");
                var cancelText = i18n.t("message.no");

                dhtmlx.confirm({
                    type: "confirm",
                    text: textText,
                    ok: okText,
                    cancel: cancelText,
                    callback: function (result) {
                        //prompt the user to upgrade
                        //if yes -> redirect to Credits.htm
                        if (result) {
                            location.href = 'Credits.htm';
                        }
                    }
                });
            } else if (jsonResp.message && jsonResp.message === 'campaignnotexists') {
                //should not appear to the user
                $.Notify.error(i18n.t("message.campaignnotexists"));
            } else {
                console.info(`${attribute} value changed successfully!`);
            }
            if (this.model.get("campaignChannel") === "EMAIL") {
                //if value < 0 then the number of recipients got reduced
                var newRemainingEmailValue = this.emailsLeft - value;
                $("#credits-cost").text(newRemainingEmailValue);
            }
        } catch (error) {
            console.error(error);
        }
    }

    isCampaignScheduled(model) {
        if (!model) model = this.model;
        return (model.get("campaignId") && model.get("campaignStatus") == "NOT_STARTED");
    }

    insertContentOnCampaign(e) {
        var id = e.model.get(e.model.idAttribute);
        var existingContentId = this.model.get("contentForUniqueCode");
        if (!existingContentId || (existingContentId && existingContentId !== id))
            this.changeContent(id);
    }

    @on("click #execute-cancel")
    async executeCancel() {
        try {
            const result = await dhtmlx.confirm({
                type: "confirm",
                text: i18n.t("message.cancelexecution"),
                ok: i18n.t("message.yes"),
                cancel: i18n.t("message.no")
            });
            if (result) {
                const response = await $.ajaxDefaultQ({
                    url: `/CampaignCloud/Message/${this.model.get("campaignId")}/executeCancel`,
                    type: 'POST'
                });

                if(response == null || response == '') {
                    dhtmlx.alert(i18n.t('profile.nopermissiontitle') + ". " + i18n.t('profile.nopermissiontext'));
                    return;
                }

                if (typeof response.message !== 'undefined') {
                    if (response.message === "campaignexecutioncanceledsuccess") {
                        await dhtmlx.alert(i18n.t(`message.${response.message}`));
                        location.reload();
                    } else {
                        dhtmlx.alert(i18n.t(`message.${response.message}`));
                    }
                }
            }
        } catch (error) {
            console.error(error);
        }

    }

    async updateMessageCount() {
        this.totalEmails = 0; //set them to `0`, in order to avoid having them being increased, on each EXECUTE click.
        this.totalSms = 0;
        if (this.model.get("description") === "tellody-event") {
            this.totalSms = this.dependenciesSmsCount ? this.dependenciesSmsCount : 0;
            this.totalEmails = this.dependenciesEmailCount ? this.dependenciesEmailCount : 0;
            if ($('#voucher-options:visible').length) {
                this.totalSms += this.dependenciesOfVoucherSmsCount ? this.dependenciesOfVoucherSmsCount : 0;
                this.totalEmails += this.dependenciesOfVoucherEmailCount ? this.dependenciesOfVoucherEmailCount : 0;
            }
            if ($('#survey-options:visible').length) {
                this.totalSms += this.dependenciesOfSurveySmsCount ? this.dependenciesOfSurveySmsCount : 0;
                this.totalEmails += this.dependenciesOfSurveyEmailCount ? this.dependenciesOfSurveyEmailCount : 0;
            }
            this.countCurrentBulkMessageCountAndRender();
        } else {
            if (this.model.get("voucherForUniqueCode") || this.model.get("surveyForUniqueCode")) {
                if (this.voucherModel && this.voucherModel.get("campaignId"))
                    this.checkIfVoucherParticipatesInEventCampaign(this.voucherModel.get("campaignId"));
                if (this.surveyModel && this.surveyModel.get("campaignId"))
                    this.checkIfSurveyParticipatesInEventCampaign(this.surveyModel.get("campaignId"));
                try {
                    const voucherParticipationDeferredData = await this.voucherParticipationDeferred;
                    const surveyParticipationDeferredData = await this.surveyParticipationDeferred;
                    /*
                     * This check is placed here because otherwise if we add and then remove a voucher or
                     * survey from message the ajax call may not have returned and the new value of totalSms and
                     * totalEmails be overridden upon return of ajax.
                     */
                    if ($('#voucher-options:visible').length || $('#survey-options:visible').length) {
                        this.totalSms = (voucherParticipationDeferredData ? voucherParticipationDeferredData.dependenciesSmsCount : 0)
                            + (surveyParticipationDeferredData ? surveyParticipationDeferredData.dependenciesSmsCount : 0);
                        this.totalEmails = (voucherParticipationDeferredData ? voucherParticipationDeferredData.dependenciesEmailCount : 0)
                            + (surveyParticipationDeferredData ? surveyParticipationDeferredData.dependenciesEmailCount : 0);
                    }
                    this.hasDependentSmsCampaigns = this.totalEmails > 0;
                    this.hasDependentEmailCampaigns = this.totalSms > 0;
                    this.countCurrentBulkMessageCountAndRender();
                } catch (error) {
                    console.error(error);
                }
            } else {
                this.hasDependentSmsCampaigns = this.totalEmails > 0;
                this.hasDependentEmailCampaigns = this.totalSms > 0;
                this.countCurrentBulkMessageCountAndRender();
            }
        }
    }

    calculateCost() {
        if (!this.creditsCost)
            this.creditsCost = 0;
        var $error = $("#error-credits-message");
        if (this.userModel && this.userModel.get("creditsAvailable") !== null
            && (this.userModel.get("creditsAvailable") < this.creditsCost)) {
            var creditsNeeded = parseFloat((this.creditsCost - this.userModel.get("creditsAvailable")).toFixed(2));
            $error.text(this.i18n.t("message.errorcreditsmessage", {count: creditsNeeded}));
            $error.show();
            $("#buy-credits").show();
            $("#credits-warning").show();
            this.areCreditsEnough = false;
        } else {
            $error.hide();
            $("#buy-credits").hide();
            $("#credits-warning").hide();
            this.areCreditsEnough = true;
        }
        if (this.creditsCost === 0) {
            this.areCreditsEnough = true;
        }
        this.trigger("calculated:campaignCost");
    }

    countCurrentBulkMessageCountAndRender() {
        if (this.model.get("campaignTemplateType") === 'BULK') {
            if (this.isSms && this.charactersCount)
                this.totalSms += this.SMScount;
            else if (this.isSms && !this.charactersCount)
                this.totalSms = 0;
            else if (this.confMessage && this.confMessage.length) {
                if (this.confMessage.includes("<p></p>")) {
                    var length = this.confMessage.length - 7;//the number of characters for <p></p>
                    if (length)
                        this.totalEmails++;
                } else
                    this.totalEmails++;
            } else
                this.totalEmails = 0;
        }
        var html = `${this.totalSms
            }<i style='font-size:80%; margin-right:25px;  margin-left:10px;' class='icon-tellody-sms' title='SMS'></i>${
            this.i18n.t('message.emailsToSend', {count: this.totalEmails})
            }<i style='font-size:80%; margin-left:10px;' class='icon-tellody-message' title='Email'></i>`;

        this.$("#messagesToSend").html(html);
        if (!this.model.get("postpaid")) {
            if (this.userModel.get("subscriptionLevel") &&
                this.userModel.get("subscriptionLevel") === 1) {
                html = this.emailsLeft;
                this.$("#emailsLeft").html(html);
            }
            if (this.model.get("description") !== "tellody-event") {
                html = (this.totalSms * this.targetGroupSizeCost).toFixed(2);
                this.creditsCost = parseFloat(html);
                this.$("#credits-cost").html(html);
            }
            this.calculateCost();
        }
    }

    checkIfVoucherParticipatesInEventCampaign(campaignId) {
        this.voucherParticipationDeferred = this.checkIfServiceParticipatesInEventCampaign(campaignId);
    }

    checkIfSurveyParticipatesInEventCampaign(campaignId) {
        this.surveyParticipationDeferred = this.checkIfServiceParticipatesInEventCampaign(campaignId);
    }

    checkIfServiceParticipatesInEventCampaign(campaignId) {
        return $.ajaxDefaultQ({
            url: `/CampaignCloud/Message/checkIfServiceParticipatesInEventCampaign/${campaignId}`,
            type: 'GET',
            contentType: "application/json",
            dataType: 'json'
        });
    }

    @on("click #delete-draft")
    deleteDraft() {
        var campaignUUID = this.model.get(this.model.idAttribute);
        dhtmlx.confirm({
            type: "confirm",
            text: i18n.t("survey.confirmdeletion"),
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no"),
            callback: async function (result) {
                if (result) {
                    try {
                        let response = await $.ajaxDefaultQ({
                            url: `/CampaignCloud/Message/${campaignUUID}/deleteDraft`,
                            type: 'POST'
                        });
                        if (typeof response.message !== 'undefined') {
                            if (response.message === "successfulDeletion") {
                                dhtmlx.alert(i18n.t(`message.${response.message}`), function () {
                                    location.href = "Message.htm";
                                });
                            } else {
                                dhtmlx.alert(i18n.t(`message.${response.message}`));
                            }
                        }
                    } catch (response) {
                        console.error(response);
                    }
                }
            }
        });
    }

    showErrors(errors) {
        var errorDiv = $("#validationErrors");
        errorDiv.empty();
        errorDiv.html(this.messageErrorTemplate({errors: errors}));
        errorDiv.show();
    }

    hideErrors() {
        var errorDiv = $("#validationErrors");
        errorDiv.hide();
    }

    addAppropriateClassOnSelectedService(viewElement, id, service) {
        $(viewElement).prop("class", ""); //clean to avoid having more than one bg classes
        if (service === "voucher") {
            $(viewElement).addClass(`ribbed-${Handlebars.helpers.tilecolorclass(id)}`);
        } else if (service === "survey") {
            $(viewElement).addClass(`bbgg-${Handlebars.helpers.tilecolorclass(id)}`);
        } else if (["optin", "instantWin", "payment"].includes(service)) {
            $(viewElement).addClass(`bbbggg-${Handlebars.helpers.tilecolorclass(id)}`);
        }
    }

    setupAutoSaveCheck() {
        var self = this;
        window.addEventListener("beforeunload", e => {
            if (this.checkIfShouldUpdateModel()) {
                this.model.batchUpdate();
                const returnValue = i18n.t('generic.confirmleaveconfig');
                e.returnValue = returnValue;
                return returnValue;
            } else {
                return null;
            }
        });
        window.setInterval(() => {
            if(this.checkIfShouldUpdateModel()) {
                this.model.batchUpdate();

                this.awaitingSavingOfFields = false;

                // add a check because it may be called from another view
                if(this.validateMessageCondition)
                    this.validateMessageCondition();

                this.refreshServices();
                this.checkForInvalidServicesAndClearThem();
            }

        }, 10000);

    }
    @on("click #get_email_html")
    serveHtml(){
        var id = this.model.get("id");
        console.log("from non generic view");
        location.href = `/CampaignCloud/emailRetrieve/${id}`;
    }
    checkIfShouldUpdateModel() {
        var self = this;
        //toDo: remove or modify this check, if any other fields need to be auto-saved
        //since we only need to "auto" update "startDate" field, we ignore all the other ones
        if(this.model.hasChanged()) {
            _.forEach(this.model.changed, function(val, key) {
                if(key != "startDate")
                    delete self.model.changed[key];
                else // check if the submitted value (in the model) is set as its placeholder
                    if(self.model.get("startDate") == i18n.t('now'))
                        self.model.set("startDate", null);
            });
        }

        return this.model.hasChanged() && this.model.changed != null && this.model.changed !== 'undefined' && !_.isEmpty(this.model.changed);
    }

}

export default MessageGenericView;
